import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function WagesWorkerAdv() {
  const dispatch = useDispatch();
  /*   ALL STATES
   ********************************************* */

  const [workerAdvList, setWorkerAdvList] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [workerList, setWorkerList] = useState([]);
  const [searchDate, setSearchDate] = useState(
    new Date().toISOString().split("T")[0]
  ); // Default to today
  const [searchWorkerName, setSearchWorkerName] = useState("");
  const [searchType, setSearchType] = useState("date"); // 'date' or 'worker'

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  //get Data
  const getWorkerAdvList = async () => {
    try {
      let queryType = searchType === "date" ? "by-date" : "by-worker";
      let queryValue = searchType === "date" ? searchDate : searchWorkerName;

      setLoading(true);
      const { data } = await API.post(
        "/manufacturer/wages/advances",
        {
          type: queryType,
          query: queryValue,
        },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setWorkerAdvList(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const getWorkerList = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/manufacturer/wages/workers", {
        headers: authHeader(),
      });
      if (data?.success) {
        setWorkerList(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete Advance
  const deleteAdvance = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/manufacturer/wages/advance/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        setWorkerAdvList((prev) => prev.filter((item) => item.id !== id));
        dispatch(
          setNotification({
            message: "Advance deleted successfully",
            type: "success",
          })
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Add Advance
  const AddAdvance = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post("/manufacturer/wages/advance", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        setWorkerAdvList((prev) => [...prev, data?.data]);
        setFormData({});
        setShowAddModal(false);
        dispatch(
          setNotification({
            message: "Advance added successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Update Advance
  const UpdateAdvance = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch(
        "/manufacturer/wages/advance",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setWorkerAdvList((prev) => {
          const newData = prev.map((item) => {
            if (item.id === formData.id) {
              return data?.data;
            }
            return item;
          });
          return newData;
        });
        setIsUpdateMode(false);
        setShowAddModal(false);
        dispatch(
          setNotification({
            message: "Advance updated successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData({
      ...item,
      advanceDate: item.advanceDate
        ? new Date(item.advanceDate).toISOString().split("T")[0]
        : "",
    });
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  // Filter data based on search criteria
  const filteredData = workerAdvList.filter((item) => {
    if (searchType === "date" && searchDate) {
      const itemDate = new Date(item.advanceDate).toDateString();
      const filterDate = new Date(searchDate).toDateString();
      return itemDate === filterDate;
    }
    if (searchType === "worker" && searchWorkerName) {
      return item.worker?.workerName
        ?.toLowerCase()
        .includes(searchWorkerName.toLowerCase());
    }
    return true;
  });

  // Calculate total amount
  const totalAmount = filteredData.reduce(
    (sum, item) => sum + (item.advanceAmount || 0),
    0
  );

  useEffect(() => {
    let timeout = setTimeout(() => {
      getWorkerAdvList();
      getWorkerList();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div className="ms-2">
      <button
        onClick={() => {
          setShowAddModal(true);
          setFormData({});
          setIsUpdateMode(false);
        }}
        type="button"
        className="btn btn-primary"
      >
        Add Advance
      </button>
    </div>
  );

  const btns = () => (
    <div className="d-flex justify-content-end align-items-center gap-1 flex-wrap me-2">
      <span className="fw-bold fs-4 mb-0 me-1">Filter:</span>
      <select
        className="form-select"
        style={{ width: "150px" }}
        value={searchType}
        onChange={(e) => setSearchType(e.target.value)}
      >
        <option value="date">By Date</option>
        <option value="worker">By Worker</option>
      </select>

      {searchType === "date" ? (
        <input
          type="date"
          className="form-control"
          style={{ width: "150px" }}
          value={searchDate}
          onChange={(e) => setSearchDate(e.target.value)}
          placeholder="Select date"
        />
      ) : (
        <input
          type="text"
          className="form-control"
          style={{ width: "180px" }}
          placeholder="Worker name"
          value={searchWorkerName}
          onChange={(e) => setSearchWorkerName(e.target.value)}
        />
      )}

      <button
        onClick={() => {
          getWorkerAdvList();
        }}
        className="btn btn-success"
        type="button"
      >
        Filter
      </button>
    </div>
  );

  const table_head = ["ID", "Worker Name", "Advance Date", "Amount", "Actions"];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="align-middle py-1">{item.advanceAmountId}</td>
      <td className="align-middle py-1">
        {workerList.find((worker) => worker.id === item.workerId)?.workerName ||
          "N/A"}
      </td>
      <td className="align-middle py-1">
        {item.advanceDate
          ? new Date(item.advanceDate).toLocaleDateString("en-GB")
          : "N/A"}
      </td>
      <td className="align-middle py-1">{item.advanceAmount || 0}</td>
      <td className="align-middle py-1">
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn px-1"
          title="Edit Payment"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn px-1"}
          deleteFunc={deleteAdvance}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="">
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div
        className="px-2 flex-grow-1 d-flex"
        style={{ height: "75vh", overflowY: "auto" }}
      >
        <div className="horizontal-scrollable d-flex flex-grow-1">
          <Table
            btn1={btn1}
            buttons={btns}
            table_head={table_head}
            table_body={table_body}
            table_data={filteredData}
          />
        </div>
      </div>
      <div className="fw-bold text-danger fs-4 mb-0 text-end border-top border-2 pt-2 px-2">
        Total Amount: {totalAmount.toFixed(2)}
      </div>

      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <div className="">
            <h4>{isUpdateMode ? "Edit Payment" : "Add Advance"}</h4>
          </div>
          <hr className="mt-0" />
          <form
            onSubmit={isUpdateMode ? UpdateAdvance : AddAdvance}
            className=""
          >
            <div className="mb-3">
              <label className="">Worker</label>
              <div className="">
                <select
                  value={formData?.workerId || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      workerId: parseInt(e.target.value),
                    });
                  }}
                  className="form-control"
                  required
                >
                  <option value="">Select Worker</option>
                  {workerList.map((worker) => (
                    <option key={worker.id} value={worker.id}>
                      {worker.workerName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-3">
              <label className="">Advance Date</label>
              <div className="">
                <input
                  type="date"
                  value={formData?.advanceDate || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      advanceDate: e.target.value,
                    });
                  }}
                  className="form-control"
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="">Advance Amount</label>
              <div className="">
                <input
                  type="number"
                  step="0.01"
                  value={formData?.advanceAmount || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      advanceAmount: parseFloat(e.target.value),
                    });
                  }}
                  className="form-control"
                  placeholder="Enter advance amount"
                  required
                />
              </div>
            </div>

            {/*   buttons
             ********************************************* */}
            <div className="mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    setShowAddModal(false);
                  }}
                  className="btn btn-secondary btn-sm"
                  type="button"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  className="btn btn-primary btn-sm ms-1"
                  type="submit"
                >
                  {isUpdateMode ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
